<template>
  <div class="signature-container">
    <canvas ref="canvas" class="signature"></canvas>
  </div>
</template>

<script>
import {onBeforeUnmount, onMounted, ref} from '@vue/composition-api'
import SignaturePad from "signature_pad";

// @see https://github.com/szimek/signature_pad#options
const defaultConfig = {
  backgroundColor: '#fff'
}

export default {
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    height: {
      type: Number,
      default: null
    }
  },

  setup(props) {
    const canvas = ref(null)
    const signaturePad = ref(null)

    const config = {
      ...defaultConfig,
      ...props.config
    }

    const resizeCanvas = () => {
      canvas.value.width = canvas.value.parentNode.offsetWidth
      if (props.height) {
        canvas.value.height = props.height;
      }
      signaturePad.value.clear()
    }

    const init = () => {
      // when shown in modal container width is 0 until it's visible
      if (canvas.value.parentNode.getBoundingClientRect().width === 0) {
        window.setTimeout(init, 100)
        return
      }

      signaturePad.value = new SignaturePad(canvas.value, config)

      window.addEventListener('resize', resizeCanvas)
      resizeCanvas()
    }

    onMounted(() => {
      init()
    })

    const getData = (type = 'image/jpeg') => {
      return signaturePad.value.toDataURL(type)
    }

    onBeforeUnmount(() => window.removeEventListener('resize', resizeCanvas))

    return {
      canvas,
      getData,
    }
  }
}
</script>

<style lang="scss">
.signature-container {
  width: 100%;

  canvas {
    background: #fff;
    border: 1px solid #efefef;
  }
}
</style>
